import { useEffect, useState } from 'react';

import { passwordsValidation } from '~/utils/password';

import type { ValidationResults } from './types';

const emptyValidationResult: ValidationResults = {
  allValid: false,
  isPasswordValid: false,
  isMatching: false,
  validations: {
    satisfiesMinimumCharacters: false,
    satisfiesCapitalCharacter: false,
    satisfiesLowercaseCharacter: false,
    satisfiesNumberCharacter: false,
    satisfiesSpecialCharacter: false,
    satisfiesNoIdenticalRun: false,
    satisfiesNoSequentialRun: false,
  },
};

export function usePasswordsWithValidation(): [
  string,
  (value: string) => void,
  string,
  (value: string) => void,
  ValidationResults,
] {
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [validationResult, setValidationResult] = useState<ValidationResults>(
    emptyValidationResult,
  );

  useEffect(() => {
    const validation = passwordsValidation(password, confirmPassword);
    setValidationResult(validation ?? emptyValidationResult);
  }, [password, confirmPassword]);

  return [
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    validationResult,
  ];
}
